import $ from 'jquery';

const DESKTOP_MENU_BREAKPOINT = 992;

function isMobile() {
    return $(window).width() < DESKTOP_MENU_BREAKPOINT;
}

const $toggle = $('.nav-toggle');
const $header = $('.header');
const $nav = $('.mobile-nav');

function openMainMenu() {
    $header.addClass('header--open');
    $nav.addClass('mobile-nav--open');
    $toggle.addClass('nav-toggle--open');
}

function closeMainMenu() {
    $header.removeClass('header--open');
    $nav.removeClass('mobile-nav--open');
    $toggle.removeClass('nav-toggle--open');
}

function openSubMenu($item) {
    $item.addClass('mobile-nav__item--open');
}

function closeSubMenu($item) {
    $item.removeClass('mobile-nav__item--open');
}


$toggle.on('click', (ev) => {
    ev.preventDefault();
    if ($toggle.hasClass('nav-toggle--open')) {
        closeMainMenu();
    } else {
        openMainMenu();
    }
});


$('.mobile-nav__link-toggle').on('click', function (ev) {
    ev.preventDefault();
    const $toggle = $(this);
    const $item = $toggle.closest('.mobile-nav__item');
    if ($item.hasClass('mobile-nav__item--open')) {
        closeSubMenu($item);
    } else {
        openSubMenu($item);
    }
});


$(window).on('scroll resize', () => {
    const scrollPos = $(window).scrollTop();

    const pairs = [
        {
            in: isMobile() && scrollPos > 60 * 2,
            out: isMobile() && scrollPos < 2
        },
        {
            in: !isMobile() && scrollPos > 114 * 2,
            out: !isMobile() && scrollPos < 2
        },
    ];

    let anyIn = pairs.some((pair) => pair.in);
    let anyOut = pairs.some((pair) => pair.out);

    if (anyIn && !$header.hasClass('header--fixed')) {
        $header.addClass('header--fixed');
    } else if (anyOut && $header.hasClass('header--fixed')) {
        $header.removeClass('header--fixed');
    }
});
